goog.provide("shadow.js.shim.module$$mui$material$TableCell$default");
shadow.js.shim.module$$mui$material$TableCell$default = shadow.js.shim.module$$mui$material$TableCell.default;
